export const portfolioData = {
  name: "Avinash Alapati",
  role: "Full Stack Developer",
  currentFocus: "Backend",
  bio: "Passionate Full Stack Developer with expertise in the MERN stack, currently focusing on backend development. I build scalable web applications and love solving complex problems through code.",
  email: "avinashalapati11@gmail.com",
  phone: "77801 39348",
  
  skills: {
    techStack: ["MongoDB", "Express.js", "Node.js", "React.js"],
    languages: ["Java", "Python", "JavaScript"],
    backend: ["MySQL", "MongoDB", "REST APIs"],
    tools: ["VS Code", "Git & GitHub", "Postman", "Jupyter Notebook"],
    softSkills: ["Communication", "Adaptability", "Leadership", "Teamwork"]
  },
  
  education: {
    degree: "B.Tech (3rd Year)",
    institution: "Kakinada Institute of Engineering & Technology"
  },
  
  projects: [
    {
      id: 1,
      title: "Wander Lust",
      description: "A full-stack web application inspired by Airbnb, designed to connect travelers with unique stays and experiences across the world. Built using the MERN stack with an intuitive and responsive interface.",
      technologies: ["MongoDB", "Express.js", "React.js", "Node.js"],
      features: ["User Authentication", "Property Listings", "Booking System", "Responsive Design"],
      color: "#3b82f6"
    }
  ],
  
  socialLinks: [
    {
      platform: "LeetCode",
      url: "https://leetcode.com/u/avinashh_26/",
      icon: "Code2"
    },
    {
      platform: "GitHub",
      url: "https://github.com/Avinash-Alapati",
      icon: "Github"
    },
    {
      platform: "GeeksforGeeks",
      url: "https://www.geeksforgeeks.org/user/avinashh26/",
      icon: "BookOpen"
    },
    {
      platform: "LinkedIn",
      url: "https://www.linkedin.com/in/avinash-alapati/",
      icon: "Linkedin"
    }
  ]
};